"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieConsentContextProvider = exports.CookieConsentContext = void 0;
var react_1 = __importStar(require("react"));
var config_1 = require("../../config");
var utils_1 = require("./utils");
var CookieConsentDialog_1 = __importDefault(require("./CookieConsentDialog"));
var DISABLE_COOKIE_CONSENT = (0, config_1.getConfig)().DISABLE_COOKIE_CONSENT;
exports.CookieConsentContext = (0, react_1.createContext)(null);
var CookieConsentContextProvider = function (_a) {
    var onStatusChange = _a.onStatusChange, disabledExternal = _a.disabled, children = _a.children;
    var disabled = disabledExternal || DISABLE_COOKIE_CONSENT === 'true';
    var _b = (0, react_1.useState)((0, utils_1.getCookieConsentStatus)() === null && !disabled), show = _b[0], setShow = _b[1];
    var onModalClose = (0, react_1.useMemo)(function () { return function (result) {
        setShow(false);
        (0, utils_1.setCookieConsentStatus)(result);
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(result);
    }; }, [onStatusChange]);
    var contextValue = (0, react_1.useMemo)(function () { return ({
        showCookieConsent: function () {
            setShow(true);
        },
        disabled: disabled,
    }); }, [disabled]);
    return (react_1.default.createElement(exports.CookieConsentContext.Provider, { value: contextValue },
        react_1.default.createElement(CookieConsentDialog_1.default, { show: show, onClose: onModalClose }),
        children));
};
exports.CookieConsentContextProvider = CookieConsentContextProvider;
